<script lang="ts">
  import { onMount } from 'svelte';
  import { replace } from 'svelte-spa-router';

  // Legacy route — processed requests are now Pending Payments.
  onMount(() => {
    replace('/employer/outstanding-invoices');
  });
</script>

<div class="redirect-message" aria-live="polite">
  <p>Redirecting to Pending Payments…</p>
</div>

<style>
  .redirect-message {
    padding: 2rem;
    color: #6b7280;
    text-align: left;
  }
</style>
